import { createSlice } from '@reduxjs/toolkit';
import { TdsTaxRegimeState } from './tdsTaxRegimeTypes';
import {createTdsTaxRegime,fetchTdsTaxRegimes,fetchTdsTaxRegimeById,updateTdsTaxRegime,deleteTdsTaxRegime,} from './tdsTaxRegimeActions';

const initialState: TdsTaxRegimeState = {
  regimes: [],
  selectedRegime: undefined,
  loading: false,
  error: undefined,
};

const tdsTaxRegimeSlice = createSlice({
  name: 'tdsTaxRegime',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createTdsTaxRegime.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createTdsTaxRegime.fulfilled, (state, action) => {
        state.loading = false;
        state.regimes.push({ ...action.meta.arg, id: action.payload.Id });
      })
      .addCase(createTdsTaxRegime.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All
      .addCase(fetchTdsTaxRegimes.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTdsTaxRegimes.fulfilled, (state, action) => {
        state.loading = false;
        state.regimes = action.payload.data;
      })
      .addCase(fetchTdsTaxRegimes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch by ID
      .addCase(fetchTdsTaxRegimeById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTdsTaxRegimeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedRegime = action.payload;
      })
      .addCase(fetchTdsTaxRegimeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update
      .addCase(updateTdsTaxRegime.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateTdsTaxRegime.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.regimes.findIndex(r => r.id === action.meta.arg.id);
        if (index !== -1) {
          state.regimes[index] = { ...state.regimes[index], ...action.meta.arg };
        }
      })
      .addCase(updateTdsTaxRegime.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete
      .addCase(deleteTdsTaxRegime.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteTdsTaxRegime.fulfilled, (state, action) => {
        state.loading = false;
        state.regimes = state.regimes.filter(r => r.id !== action.meta.arg);
      })
      .addCase(deleteTdsTaxRegime.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default tdsTaxRegimeSlice.reducer;
